import axios from 'axios'
import {
  ElMessage,
  ElLoading
} from 'element-plus'

// =======================
// Loading 管理（防止重复）
// =======================
let loadingInstance = null
let loadingCount = 0

function startLoading() {
  if (loadingCount === 0) {
    loadingInstance = ElLoading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.5)'
    })
  }
  loadingCount++
}

function closeLoading() {
  loadingCount--
  if (loadingCount <= 0) {
    loadingInstance?.close()
    loadingInstance = null
    loadingCount = 0
  }
}
const apiBaseUrl = process.env.NODE_ENV === 'development' ? 'http://192.168.1.86:8350' : 'https://lian.ocn.com.cn'
// =======================
// Axios 实例
// =======================
const service = axios.create({
  baseURL: apiBaseUrl, // vite 环境变量
  timeout: 10000
})

// =======================
// 请求拦截器
// =======================
service.interceptors.request.use(
  config => {
    // 显示 loading
    startLoading()

    // 示例：携带 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.AuthToken = `${token}`
    }

    return config
  },
  error => {
    closeLoading()
    ElMessage.error('请求失败')
    return Promise.reject(error)
  }
)

// =======================
// 响应拦截器
// =======================
service.interceptors.response.use(
  response => {
    closeLoading()

    const {status1} = response
    // ✅ 响应数据处理
    const { code, msg, data } = response.data

    // ✅ 根据后端业务码处理
    if (code === 200 || code === 0) {
      return data
    } else {
      ElMessage.error(msg || '业务异常')
      // return Promise.reject(new Error(msg))
    }
  },
  error => {
    closeLoading()

    // ❌ HTTP 错误
    if (error.response) {
      const status = code
      switch (status) {
        case 401:
          ElMessage.error('未登录或登录过期')
          break
        case 403:
          ElMessage.error('无权限访问')
          break
        case 404:
          ElMessage.error('接口不存在')
          break
        case 500:
          ElMessage.error('服务器错误')
          break
        default:
          ElMessage.error(`请求错误：${status}`)
      }
    } else if (error.code === 'ECONNABORTED') {
      ElMessage.error('请求超时')
    } else {
      ElMessage.error('网络异常')
    }

    return Promise.reject(error)
  }
)

export default service